<template>
  <div class="flex items-center justify-center w-full h-48 animate-pulse">
    <LoaderCircle class="animate-spin h-8 w-8" />
  </div>
</template>

<script setup lang="ts">
import { LoaderCircle } from 'lucide-vue-next'
</script>

<style>
  
</style>